var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8554 23.2517C14.7339 23.2517 16.5352 23.0571 18.2045 22.7003C20.2897 22.2546 21.3324 22.0317 22.2838 20.7489C23.2352 19.4662 23.2352 17.9938 23.2352 15.0487V12.9513C23.2352 10.0062 23.2352 8.53373 22.2838 7.25101C21.3324 5.9683 20.2897 5.74544 18.2045 5.29971C16.5352 4.94287 14.7339 4.74829 12.8554 4.74829C10.977 4.74829 9.17568 4.94287 7.50627 5.29971C5.42107 5.74544 4.37848 5.9683 3.42706 7.25101C2.47565 8.53373 2.47565 10.0062 2.47565 12.9513V15.0487C2.47565 17.9938 2.47565 19.4662 3.42706 20.7489C4.37848 22.0317 5.42107 22.2546 7.50627 22.7003C9.17568 23.0571 10.977 23.2517 12.8554 23.2517Z",
    stroke: "white",
    strokeWidth: 1.19577
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0718 14.3455C16.9139 15.0138 16.0735 15.4938 14.3928 16.4538C12.5647 17.4979 11.6507 18.02 10.9104 17.8189C10.6597 17.7507 10.4287 17.6309 10.2348 17.4684C9.66223 16.9886 9.66223 15.9925 9.66223 14.0004C9.66223 12.0082 9.66223 11.0121 10.2348 10.5323C10.4287 10.3698 10.6597 10.25 10.9104 10.1819C11.6507 9.98078 12.5647 10.5028 14.3928 11.5469C16.0735 12.5069 16.9139 12.9869 17.0718 13.6552C17.1256 13.8827 17.1256 14.1181 17.0718 14.3455Z",
    stroke: "white",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.03ebc61d136ecb183b494fefebb23ee9.svg";
export { ForwardRef as ReactComponent };